<script setup lang="ts">
import { sizeNormalize } from "~/common/helpers/size-adapter";
import type { SizeTrimmed } from "~/common/interfaces/size-trimmed";

const props = defineProps({
	sizes: {
		type: Array as PropType<SizeTrimmed[]>,
		default () {
			return [];
		}
	}
});
const emit = defineEmits<{(event: "change:size", size: SizeTrimmed): void }>();

const selectedSize = ref(0);
const sizesAdapted = computed(() => props.sizes.map(size => sizeNormalize(size)));

const updateSize = (size: SizeTrimmed) => {
	selectedSize.value = size.id;

	emit("change:size", size);
};

if (props.sizes.length) {
	updateSize(props.sizes[0]);
}
</script>

<template>
	<ul class="flex flex-wrap gap-3">
		<li v-for="size in sizesAdapted" :key="size.id">
			<CommonRadioTag
				:model-value="selectedSize.toString()"
				:value="size.id.toString()"
				@change="updateSize(size)"
			>
				{{ size.name }}
			</CommonRadioTag>
		</li>
	</ul>
</template>
